module.exports = __webpack_public_path__ + "static/img/30er-lampe.9337a18.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/30er-lampe.png
// module id = 116
// module chunks = 0